import { CloudCommand } from "../types.js";

export const deleteMessage: CloudCommand = {
    action: "MESSAGE/DELETE",
    commandName: "message.deleteMessage",
    buildPayload: ({ params }) => params,
};
